<footer id="footer" class="footer footer-static footer-light navbar-shadow content-dssawere" *ngIf="showFooter">
  <div class="clearfix d-flex flex-wrap">
    <!-- <span class="logo">
      <a [href]="upoLink" target="_blank">
        <img [src]="upoLogoUrl" />
      </a>
    </span> -->
    <span class="logo">
      <a [href]="ueLink" target="_blank">
        <img [src]="ueLogoUrl" />
      </a>
    </span>
    <span class="logo">
      <a [href]="governmentLink" target="_blank">
        <img [src]="governmentLogoUrl" />
      </a>
    </span>
      
    <span class="copyright ms-lg-auto align-self-center">
      <a [routerLink]="['/']"><b>DSS-AWERE</b></a> © 2025 by <a href="https://spatialecologygroup.blogspot.com/p/people.html" target="_blank"><b>Luis E. Santamaría Galdón & María Belenguer Manzanedo</b></a> is licensed under <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank">CC BY-NC-SA 4.0</a><img src="https://mirrors.creativecommons.org/presskit/icons/cc.svg" alt="" style="max-width: 1em;max-height:1em;margin-left: .2em;margin-top:-.2em;"><img src="https://mirrors.creativecommons.org/presskit/icons/by.svg" alt="" style="max-width: 1em;max-height:1em;margin-left: .2em;margin-top:-.2em;"><img src="https://mirrors.creativecommons.org/presskit/icons/nc.svg" alt="" style="max-width: 1em;max-height:1em;margin-left: .2em;margin-top:-.2em;"><img src="https://mirrors.creativecommons.org/presskit/icons/sa.svg" alt="" style="max-width: 1em;max-height:1em;margin-left: .2em;margin-top:-.2em;">
    </span>
    <!--<span class="links ms-lg-auto align-self-center">
      <a [href]="privacyPolicyPage" target="_blank">
        {{ 'footer.privacy' | translate }}
      </a>
      <a [href]="termsConditionsPage" target="_blank">
        {{ 'footer.legal' | translate }}
      </a>
      <a [href]="contactPage" target="_blank">
        {{ 'footer.contact' | translate }}
      </a>
      <span id="scroll-top"></span>
    </span>-->
  </div>
</footer>

<footer id="footer" class="footer fixed-bottom footer-light navbar-border navbar-shadow" *ngIf="fixedFooter">
  
  <div class="clearfix d-flex flex-wrap">
    <!-- <span class="logo">
      <a [href]="upoLink" target="_blank">
        <img [src]="upoLogoUrl" />
      </a>
    </span> -->
    <span class="logo">
      <a [href]="ueLink" target="_blank">
        <img [src]="ueLogoUrl" />
      </a>
    </span>
    <span class="logo">
      <a [href]="governmentLink" target="_blank">
        <img [src]="governmentLogoUrl" />
      </a>
    </span>
    <span class="links ms-lg-auto align-self-center">
      <a [href]="privacyPolicyPage" target="_blank">
        {{ 'footer.privacy' | translate }}
      </a>
      <a [href]="termsConditionsPage" target="_blank">
        {{ 'footer.legal' | translate }}
      </a>
      <a [href]="contactPage" target="_blank">
        {{ 'footer.contact' | translate }}
      </a>
      <span id="scroll-top"></span>
    </span>
  </div>
</footer>

<footer id="footer" class="footer fixed-bottom footer-dark navbar-border navbar-shadow" *ngIf="darkFooter">
  
  <div class="clearfix d-flex flex-wrap">
    <!-- <span class="logo">
      <a [href]="upoLink" target="_blank">
        <img [src]="upoLogoUrl" />
      </a>
    </span> -->
    <span class="logo">
      <a [href]="ueLink" target="_blank">
        <img [src]="ueLogoUrl" />
      </a>
    </span>
    <span class="logo">
      <a [href]="governmentLink" target="_blank">
        <img [src]="governmentLogoUrl" />
      </a>
    </span>
    <span class="links ms-lg-auto align-self-center">
      <a [href]="privacyPolicyPage" target="_blank">
        {{ 'footer.privacy' | translate }}
      </a>
      <a [href]="termsConditionsPage" target="_blank">
        {{ 'footer.legal' | translate }}
      </a>
      <a [href]="contactPage" target="_blank">
        {{ 'footer.contact' | translate }}
      </a>
      <span id="scroll-top"></span>
    </span>
  </div>
</footer>
